<template>
  <div class="page">
    <ion-grid>
      <ion-row class="row-divider"></ion-row>
      <ion-row class="search-view">
        <ion-col>
          <ion-row align-items-stretch>
            <ion-col size="12" size-md="3">
              <ion-label>Reservation No</ion-label>
              <div class="border-line-34 margin-top-10">
                <ion-input class="form-input" type="text" id="id" @input="id = $event.target.value"></ion-input>
              </div>
            </ion-col>
            <ion-col size="12" size-md="3">
              <ion-label>Charging Station</ion-label>
              <div class="border-line-34 margin-top-10">
                <ion-input
                  class="form-input"
                  type="text"
                  id="stationName"
                  @input="stationName = $event.target.value"
                ></ion-input>
              </div>
            </ion-col>
            <ion-col size="12" size-md="3">
              <ion-label>Customer Name/Mobile</ion-label>
              <div class="border-line-34 margin-top-10">
                <ion-input
                  class="form-input"
                  type="text"
                  id="customerName"
                  @input="customerName = $event.target.value"
                ></ion-input>
              </div>
            </ion-col>
            <ion-col size="12" size-md="3">
              <ion-label>Status</ion-label>
              <div class="border-line-34 margin-top-10">
                <ion-select
                  class="form-select select-mobile"
                  :value="status"
                  @ionChange="status = $event.target.value"
                  placeholder="Select Status"
                  interface="action-sheet"
                >
                  <ion-select-option
                    v-for="(status, index) in this.statuses"
                    :key="index"
                    :value="status.id"
                  >{{status.name}}</ion-select-option>
                </ion-select>

                <select
                  class="input-select select-web"
                  v-model="status"
                  placeholder="Select Status"
                >
                  <option
                    v-for="(status, index) in this.statuses"
                    :key="index"
                    :value="status.id"
                  >{{ status.name }}</option>
                </select>
              </div>
            </ion-col>
            <ion-col size="12" size-md="3">
              <ion-label>Reservation Date From</ion-label>
              <div class="date-picker-box margin-top-10 datepicker-web">
                <datepicker
                  class= "form-vue-picker"
                  placeholder= "DD/MON/YYYY"
                  inputFormat="dd/MMM/yyyy"
                  v-model="reservFrom"
                  :typeable="true"
                  :lowerLimit ="sixMonthsAgo"
                  :upperLimit ="currentDate"
                ></datepicker>
                <span class="custom-calendar-icon">
                  <img src="/../assets/images/common/datepicker/calendar.png" />
                </span>
              </div>
              <div class="border-line-34 margin-top-10 datepicker-mobile">
                <!-- <div class="input-icon-calendar"> -->
                  <!-- <ion-datetime
                    class="form-picker"
                    placeholder="Select From Date"
                    displayFormat="YYYY, MM, DD"
                    @ionChange="reservFrom = $event.target.value"
                  ></ion-datetime> -->
                  <datepicker
                    class= "form-picker"
                    placeholder= "Select From Date"
                    inputFormat="MMM dd, yyyy"
                    v-model="reservFrom"
                    :typeable="true"
                    :lowerLimit ="sixMonthsAgo"
                    :upperLimit ="currentDate"
                ></datepicker>
                <span class="input-icon-calendar">
                    <img src="/../assets/images/common/datepicker/calendar.png" />
                  </span>
                <!-- </div> -->
              </div>
            </ion-col>
            <ion-col size="12" size-md="3">
              <ion-label>Reservation Date To</ion-label>
              <div class="date-picker-box margin-top-10 datepicker-web">
                <datepicker
                  class= "form-vue-picker"
                  placeholder= "DD/MON/YYYY"
                  inputFormat="dd/MMM/yyyy"
                  v-model="reservTo"
                  :lowerLimit="sixMonthsAgo"
                  :upperLimit="maxDate"
                  :typeable= "true"
                ></datepicker>
                <span class="custom-calendar-icon">
                  <img src="/../assets/images/common/datepicker/calendar.png" />
                </span>
              </div>
              <div class="border-line-34 margin-top-10 datepicker-mobile">
                <!-- <div class="input-icon-calendar"> -->
                  <!-- <ion-datetime
                    class="form-picker"
                    placeholder="Select To Date"
                    displayFormat="YYYY, MM, DD"
                    @ionChange="reservTo = $event.target.value"
                  ></ion-datetime> -->
                  <datepicker
                    class= "form-picker"
                    placeholder= "Select To Date"
                    inputFormat="MMM dd, yyyy"
                    v-model="reservTo"
                    :lowerLimit="sixMonthsAgo"
                    :upperLimit="maxDate"
                    :typeable= "true"
                ></datepicker>
                <span class="input-icon-calendar">
                    <img src="/../assets/images/common/datepicker/calendar.png" />
                  </span>
                <!-- </div> -->
              </div>
            </ion-col>
            <ion-col size="12" size-md="3">
              <ion-label>Invoice Date From</ion-label>
              <div class="date-picker-box margin-top-10 datepicker-web">
                <datepicker
                  class="form-vue-picker"
                  placeholder="DD/MON/YYYY"
                  inputFormat="dd/MMM/yyyy"
                  v-model="invoiceFrom"
                  :typeable="true"
                ></datepicker>
                <span class="custom-calendar-icon">
                  <img src="/../assets/images/common/datepicker/calendar.png" />
                </span>
              </div>
              <div class="border-line-34 margin-top-10 datepicker-mobile">
                <!-- <div class="input-icon-calendar"> -->
                  <!-- <ion-datetime
                    class="form-picker"
                    placeholder="Select From Date"
                    displayFormat="YYYY, MM, DD"
                    @ionChange="invoiceFrom = $event.target.value"
                  ></ion-datetime> -->
                  <datepicker
                    class= "form-picker"
                    placeholder= "Select From Date"
                    inputFormat="MMM dd, yyyy"
                    v-model= "invoiceFrom"
                    :typeable= "true"
                ></datepicker>
                <span class="input-icon-calendar">
                    <img src="/../assets/images/common/datepicker/calendar.png" />
                  </span>
                <!-- </div> -->
              </div>
            </ion-col>
            <ion-col size="12" size-md="3">
              <ion-label>Invoice Date To</ion-label>
              <div class="date-picker-box margin-top-10 datepicker-web">
                <datepicker
                  class="form-vue-picker"
                  placeholder="DD/MON/YYYY"
                  inputFormat="dd/MMM/yyyy"
                  v-model="invoiceTo"
                  :typeable="true"
                ></datepicker>
                <span class="custom-calendar-icon">
                  <img src="/../assets/images/common/datepicker/calendar.png" />
                </span>
              </div>
              <div class="border-line-34 margin-top-10 datepicker-mobile">
                <!-- <div class="input-icon-calendar"> -->
                  <!-- <ion-datetime
                    class="form-picker"
                    placeholder="Select To Date"
                    displayFormat="YYYY, MM, DD"
                    @ionChange="InvoiceTo = $event.target.value"
                  ></ion-datetime> -->
                  <datepicker
                    class= "form-picker"
                    placeholder= "Select To Date"
                    inputFormat="MMM dd, yyyy"
                    v-model= "invoiceTo"
                    :typeable= "true"
                ></datepicker>
                <span class="input-icon-calendar">
                    <img src="/../assets/images/common/datepicker/calendar.png" />
                  </span>
                <!-- </div> -->
              </div>
            </ion-col>
            <ion-col size="12" size-md="3">
              <ion-label>Invoice No</ion-label>
              <div class="border-line-34 margin-top-10">
                <ion-input
                  class="form-input"
                  type="text"
                  id="invoiceNo"
                  @input="invoiceNo = $event.target.value"
                ></ion-input>
              </div>
            </ion-col>
            <ion-col size="12" size-md="3">
              <ion-label>Stop Reason</ion-label>
              <div class="border-line-34 margin-top-10">
                <ion-select
                  class="form-select select-mobile"
                  :value="reason"
                  @ionChange="reason = $event.target.value"
                  interface="action-sheet"
                >
                  <ion-select-option
                    v-for="(reason, index) in this.stopReasons"
                    :key="index"
                    :value="reason"
                  >{{reason}}</ion-select-option>
                </ion-select>

                <select
                  class="input-select select-web"
                  v-model="reason"
                >
                  <option
                    v-for="(reason, index) in this.stopReasons"
                    :key="index"
                    :value="reason"
                  >{{ reason }}</option>
                </select>
              </div>
            </ion-col>
            <ion-col size="12" size-md="3">
              <br />
              <ion-button class="btn-search margin-top-10" @click="searchReservations">Search</ion-button>
              <ion-button class="btn-clear margin-top-10" @click="clearFields">
                <ion-icon :icon="refresh"></ion-icon>
              </ion-button>
            </ion-col>
          </ion-row>
        </ion-col>
      </ion-row>
      <ion-row class="row-divider"></ion-row>
      <ion-row class="list-view">
        <ion-col>
          <ion-row class="list-head">
            <ion-col size="12" size-md="1">
              <ion-label>Res.No</ion-label>
            </ion-col>
            <ion-col size="12" size-md="1.3">
              <ion-label>Charging Station</ion-label>
            </ion-col>
            <ion-col size="12" size-md="1">
              <ion-label>Name</ion-label>
            </ion-col>
            <ion-col size="12" size-md="1">
              <ion-label>Mobile</ion-label>
            </ion-col>
            <!-- Below code is commented by vinoth on 18.08.2025, we no need to display reservation date-->
            <ion-col size="12" size-md="1">
              <ion-label>Res.Date</ion-label>
            </ion-col>
            <ion-col size="12" size-md="1">
              <ion-label>Inv. #</ion-label>
            </ion-col>
            <ion-col size="12" size-md="1">
              <ion-label>Inv. Date</ion-label>
            </ion-col>
            <ion-col size="12" size-md="0.7">
              <ion-label>Output Name</ion-label>
            </ion-col>
            <!-- <ion-col size="12" size-md="0.5">
              <ion-label>Port Name</ion-label>
            </ion-col> -->
            <ion-col size="12" size-md="0.5">
              <ion-label>Inv. Total</ion-label>
            </ion-col>
            <ion-col size="12" size-md="0.5">
              <ion-label>kWh</ion-label>
            </ion-col>
            <ion-col size="12" size-md="1">
              <ion-label>Time Completed</ion-label>
            </ion-col>
            <!-- Below reason column is added by vinoth on 18.08.2025, we  need to display reservation cpmplete reason-->
            <ion-col size="12" size-md="1">
              <ion-label>Reason</ion-label>
            </ion-col>
            <ion-col size="12" size-md="1">
              <ion-label>Status</ion-label>
            </ion-col>
          </ion-row>
          <hr />
          <ion-row class="list-item" v-for="(reservation) in this.reservations" :key="reservation">
            <ion-col size="12" size-md="1">
              <ion-label
                class="ext-link"
                @click="viewReservation(reservation.id)"
              >{{reservation.refNo}}</ion-label>
            </ion-col>
            <ion-col size="12" size-md="1.3"  style="cursor: pointer;" @click="addStationNameInFilter(reservation.station.name)">
              <ion-label>{{reservation.station.name}}</ion-label>
            </ion-col>
            <ion-col class="limit-length" style="cursor: pointer;" size="12" size-md="1" @click="addMobileInFilter(reservation.customer.profile.mobile)">
              <ion-label>{{reservation.customer.profile.firstName}} {{reservation.customer.profile.lastName}}</ion-label>
            </ion-col>
            <ion-col size="12" size-md="1"  style="cursor: pointer;" @click="addMobileInFilter(reservation.customer.profile.mobile)">
              <ion-label>{{reservation.customer.profile.mobile}}</ion-label>
            </ion-col>
            <!-- Below code is commented by vinoth on 18.08.2025, we no need to display reservation date-->
            <ion-col size="12" size-md="1">
              <ion-label>{{changeDateFormat(reservation.slot.startsOn)}}</ion-label>
            </ion-col>
            <ion-col size="12" size-md="1">
              <ion-label>{{reservation.invoice.invoiceNo}}</ion-label>
            </ion-col>
            <ion-col size="12" size-md="1">
              <ion-label>{{changeDateFormatWithoutTime(reservation.invoice.invoiceOn)}}</ion-label>
            </ion-col>
            <ion-col size="12" size-md="0.7">
              <ion-label>{{reservation.bayName}}</ion-label>
            </ion-col>
            <!-- <ion-col size="12" size-md="0.5">
              <ion-label>{{reservation.portName}}</ion-label>
            </ion-col> -->
            <!-- Below code commented by vinoth because expecting amount should display with paise but it is displaying only round of amount  -->
            <!-- <ion-col size="12" size-md="1">
              <ion-label>{{reservation.invoice.invoiceAmount}}</ion-label>
            </ion-col> -->
            
             <ion-col size="12" size-md="0.5">
              <ion-label v-if="reservation.invoice.invoiceAmount == null">{{reservation.invoice.invoiceAmount}}</ion-label>
              <ion-label v-if="reservation.invoice.invoiceAmount != null">{{reservation.invoice.invoiceAmount.toFixed(2)}}</ion-label>
            </ion-col>
            <ion-col size="12" size-md="0.5">
              <ion-label v-if="reservation.commercial.actual">{{reservation.commercial.actual.unit}}</ion-label>
            </ion-col>
            <ion-col size="12" size-md="1">
              <ion-label  v-if="reservation.status.id === 'C'">{{reservation.timeCompleted}}</ion-label>
            </ion-col>
            <!-- Below reason column is added by vinoth on 18.08.2025, we  need to display reservation cpmplete reason-->
            <ion-col size="12" size-md="1">
              <ion-label>{{reservation.cmsAdditionalMessage}}</ion-label>
              <br />
              <ion-label class="section-desc" v-if="reservation.otherError != null">{{reservation.otherError}}</ion-label>
            </ion-col>
            <ion-col size="12" size-md="1">
              <ion-label
                style="white-space: nowrap;"
                class="status-small"
                v-bind:class="[{'open': reservation.status.id === 'O'}, {'cancelled': reservation.status.id === 'X'}, {'wip': reservation.status.id === 'P'}, {'expired': reservation.status.id === 'E'}, {'completed': reservation.status.id === 'C'}]"
              >{{convertUppercase(reservation.status.name)}}</ion-label>
              </ion-col>
          </ion-row>
        </ion-col>
      </ion-row>
      <ion-row class="row-divider"></ion-row>
      <ion-row v-if="norecordsfound">
        <ion-col size="12" class="ion-text-center">
          <ion-label class="pagination-info">No records found for the selected filters</ion-label>
        </ion-col>
      </ion-row>
      <ion-row v-else>
        <ion-col size="12" size-md="5">
          <ion-label
            class="pagination-info"
          >Showing {{((pageRecords * pageNo) <= totalRecords) ? (pageRecords * pageNo) : totalRecords}} of {{totalRecords}} results</ion-label>
        </ion-col>
        <ion-col size="12" size-md="7" class="ion-text-right">
          <div class="pagination">
            <a class="prev" v-if="this.pageNo > 1" @click="loadPage(pageNo - 1)">Prev</a>
            <a class="prev disabled" v-else>Prev</a>
            <a
              
              v-for="page in this.pagesList"
              :key="page"
              v-bind:class="{'active': pageNo == page}"
              @click="loadPage(page)"
            >{{page}}</a>
            <a
              
              class="next"
              v-if="this.pageNo < this.totalPages"
              @click="loadPage(pageNo + 1)"
            >Next</a>
            <a class="next disabled" v-else>Next</a>
          </div>
        </ion-col>
      </ion-row>
    </ion-grid>
    <div class="spinner">
      <ion-spinner v-if="loaderTab"></ion-spinner>
    </div>
  </div>
</template>

<script>
import { defineComponent } from "vue";
import { EVCStationReservationService } from "../../service/evcstation/reservation.service";
import { EVChargingReservationStatus } from "@/entity/station/reservation";

import { LocalStorage } from "../../data/localstorage";
import { ToastUtils } from "../../util/toast-utils";
import { migratedTryParseServiceError } from "../../service";
import { PaginationUtils } from "../../util/pagination-utils";
import { refresh } from 'ionicons/icons';
// import Datepicker from "vuejs-datepicker/dist/vuejs-datepicker.esm.js";
import datepicker from 'vue3-datepicker';
import { IonButton, IonCol, IonGrid, IonIcon, IonInput, IonLabel, IonRow, IonSelect, IonSelectOption, IonSpinner } from "@ionic/vue";
import moment from "moment";

import { CorporateService } from "../../service/corporate/corporate.service";
import { NewAddress } from "@/entity/location/address";

export default defineComponent ({
  name: 'reservations',
  components: {
    datepicker, IonIcon, IonGrid, IonRow, IonCol, IonLabel, IonInput, IonSelect, IonSelectOption, IonButton, IonSpinner
  },
  data() {
    return {
      refresh,
      loaderTab: true,
      reservations: [],
      statuses: [],
      types: [],
      statusModels: [],
      typeModels: [],
      id: "",
      stationName: "",
      customerName: "",
      reservationType: "",
      // reservFrom: "",
      // reservTo: "",
      status: "",
      invoiceFrom: "",
      invoiceTo: "",
      invoiceNo: "",

      norecordsfound: true,
      totalRecords: 0,
      pageRecords: 10,
      pageNo: 1,
      pagesList: [],
      totalPages: 0,
      
      reservFrom: new Date(),
      reservTo: new Date(),
      configDays: 0,
      configMonths: 0,
      maxDate: new Date(), // Current date
      currentDate: new Date(),
      sixMonthsAgo: new Date(),
      reason: "",
      stopReasons: [],
      
    }
  },
  async mounted() {
    try {  
      await this.getDateAndMonth()
      await this.getDateDaysAgo(this.configDays)
      await this.getDateMonthsAgo(this.configMonths)
      await this.setReservationToDate(this.configDays)
      this.types = await new EVCStationReservationService().reservationTypes();
      this.statuses = await new EVCStationReservationService().reservationStatuses();

      this.statusModels = [];
      this.statuses.forEach((status) => {
        this.statusModels.push({
          text: status.name,
          value: status.id,
        });
      });

      this.typeModels = [];
      this.types.forEach((type) => {
        this.typeModels.push({
          text: type.info.name,
          value: type.info.id,
        });
      });

      // Reason filter API
      this.stopReasons = await new EVCStationReservationService().getStopReason();
      
      var page = localStorage.getItem("reservationPage");
      if (page) {
        this.pageNo = Number(page);
      }
      var search = localStorage.getItem("reservationSearch");
      if (search) {
        try {
          search = JSON.parse(search);
          // console.log(search);
          // this.id = search.id;
          // this.stationName = search.stationName;
          // this.customerName = search.customerName;
          document.getElementById("id").value = search.id;
          this.id = search.id;
          document.getElementById("stationName").value = search.stationName;
          this.stationName = search.stationName;
          document.getElementById("customerName").value = search.customerName;
          this.customerName = search.customerName;
          // this.reservationType = search.reservationType;
          this.reservFrom = new Date(search.reservFrom);
          this.reservTo = new Date(search.reservTo);
          this.status = search.status;
          this.invoiceFrom = (search.invoiceFrom != null ? new Date(search.invoiceFrom) : null);
          this.invoiceTo = (search.invoiceTo != null ? new Date(search.invoiceTo) : null);
          document.getElementById("invoiceNo").value = search.invoiceNo;
          this.invoiceNo = search.invoiceNo;
          this.reason = search.reason;

          // await this.searchReservations();
        } catch (e){
          alert(e)
        }
        
      }
      await this.searchReservations();
      this.loaderTab = false;
    } catch(error) {
      this.loaderTab = false;
      let serviceError = migratedTryParseServiceError(error);
      new ToastUtils().presentToast(serviceError.description);
    }
    
  },

  methods: {
    async getDateAndMonth() {
      this.configValue = await new CorporateService().getConfigValueOfDateAndMonth()
      this.configDays = this.configValue[0].description;
      this.configMonths = this.configValue[1].description
    },
    // Helper function to calculate a date 'n' days ago
    async getDateDaysAgo(days) {
      const date = new Date();
      date.setDate(date.getDate() - days);

      this.reservFrom =  date;
    },
    async getDateMonthsAgo(months) {
      const date = new Date();
      date.setMonth(date.getMonth() - months);
      this.sixMonthsAgo = date;
    },
    async setReservationToDate(days) {
      const today = new Date();
      // const futureDate = new Date();
      const futureDate = new Date(today.getTime() + days * 24 * 60 * 60 * 1000);
      // const date = new Date();
      // date.setDate(date.getDate() + days);

      this.reservTo =  futureDate;
    },
    changeDateFormat(dateValue) {
      return moment(dateValue).format('DD/MMM/YYYY HH:mm')
    },
    changeDateFormatWithoutTime(dateValue) {
      
      if(dateValue != null) {
        return moment(dateValue).format('DD/MMM/YYYY')
      }
      
    },
    convertUppercase(value) {
      return value.toUpperCase()
    },
    viewReservation(reservationId) {
      this.$router.push({
        name: "reservationView",
        params: { reservationId: reservationId },
      });
    },
    addStationNameInFilter(name) {
      document.getElementById('stationName').value = name;
      this.stationName = name;
    },
    addMobileInFilter(mobile) {
      document.getElementById('customerName').value = mobile;
      this.customerName = mobile;
    },
    async clearFields() {
      this.pageRecords = 10,
      this.pageNo = 1
      this.id = null;
      this.stationName = null;
      this.customerName = null;
      document.getElementById("id").value = null;
      document.getElementById("stationName").value = null;
      document.getElementById("customerName").value = null;
      this.reservationType = null;
      this.reservFrom = null;
      this.reservTo = null;
      this.status = null;
      this.invoiceFrom = null;
      this.invoiceTo = null;
      this.reason = null;
      document.getElementById("invoiceNo").value = null;
      this.invoiceNo = null;
      localStorage.removeItem("reservationSearch");
      localStorage.removeItem("reservationPage");
      this.reservations = [];
      this.reservTo = new Date()
      await this.getDateAndMonth()
      await this.getDateDaysAgo(this.configDays)
      await this.getDateMonthsAgo(this.configMonths)
      await this.setReservationToDate(this.configDays)
      this.searchReservations();
      this.norecordsfound = true; //Modified by Swide on 2020-12-16 Bug#3 
    },
    async searchReservations() {
      try {
        let existingFilterData = JSON.parse(localStorage.getItem("reservationSearch"))
        let searchFilterData = {
          id: this.id,
          stationName: this.stationName,
          customerName: this.customerName,
          reservationType: this.reservationType,
          reservFrom: this.reservFrom,
          reservTo: this.reservTo,
          status: this.status,
          invoiceFrom: (this.invoiceFrom != null && this.invoiceFrom != "") ? new Date(this.invoiceFrom) : null,
          invoiceTo: (this.invoiceTo != null && this.invoiceTo != "") ? new Date(this.invoiceTo) : null,
          invoiceNo: this.invoiceNo,
          reason: this.reason
        }
        if(!this.areFiltersEqual(searchFilterData, existingFilterData)) {
          localStorage.setItem("reservationSearch",JSON.stringify(searchFilterData));
          this.pageNo = 1;
          localStorage.setItem('reservationPage', this.pageNo);
        } else {
          let pageNo = localStorage.getItem('reservationPage');
          if(pageNo) {
            this.pageNo = pageNo;
          } else {
            this.pageNo = 1;
          }
        }
        localStorage.setItem("reservationSearch",JSON.stringify(searchFilterData));
        this.pageRecords = 10;
        // let pageNo = localStorage.getItem('reservationPage');
        // if(pageNo) {
        //   this.pageNo = pageNo;
        // } else {
        //   this.pageNo = 1;
        // }
        // this.pageNo = 1;
        let dateRange =  (new Date(this.reservTo) - new Date(this.reservFrom));
        let dateRangeBetween = dateRange/(1000*60*60*24);
        if (
          this.reservFrom &&
          this.reservTo &&
          new Date(this.reservFrom) > new Date(this.reservTo)
        ) {
          new ToastUtils().presentToast(
            "Please select correct date range of Reservation. From date should less than To date"
          );
          this.reservations = [];
          this.norecordsfound = true;
        } else if(Math.round(dateRangeBetween) > (this.configDays * 2)) {
            this.loaderTab = false;
            new ToastUtils().presentToast("Please select valid date range. The report can be viewed for a maximum of "+ (this.configDays * 2) + " days");
            this.reservations = [];
            this.norecordsfound = true;
            this.loaderTab = false;
        } else if (
          this.invoiceFrom &&
          this.invoiceTo &&
          new Date(this.invoiceFrom) > new Date(this.invoiceTo)
        ) {
          new ToastUtils().presentToast(
            "Please select correct date range of Invoice. From date should less than To date"
          );
          this.reservations = [];
          this.norecordsfound = true;
        } else {
          this.loaderTab = true;
          let result = await new EVCStationReservationService().reservationsAccessibleByUserAtPageByPaginatedWithSizeMatchingQuery(
            new LocalStorage().user,
            this.pageNo,
            this.pageRecords,
            {
              id: this.id,
              station: {
                name: this.stationName,
              },
              customer: {
                name: this.customerName,
              },
              reservedBetween: {
                from: this.reservFrom ? new Date(this.reservFrom) : null,
                to: this.reservTo ? new Date(this.reservTo) : null,
              },
              types: null, // new EVChargingReservationTypeCode[{}](),
              status: new EVChargingReservationStatus(this.status, ""),
              invoicedBetween: {
                from: (this.invoiceFrom != null && this.invoiceFrom != "") ? new Date(this.invoiceFrom) : null,
                to: (this.invoiceTo != null && this.invoiceTo != "") ? new Date(this.invoiceTo) : null,
              },
              invoiceNumber: this.invoiceNo,
              stopReason: this.reason,
            }
          );
          this.totalRecords = result.total;
          this.reservations = result.fetched;
          if(this.totalRecords > 0) {
            (this.pagesList = new PaginationUtils().getPagesList(
              this.totalRecords,
              this.pageRecords,
              this.pageNo
            )),
              (this.totalPages = new PaginationUtils().getTotalPages(
                this.totalRecords,
                this.pageRecords
              ));
            this.norecordsfound = false;
          } else {
            this.norecordsfound = true;
          }
          
          this.loaderTab = false;
          new ToastUtils().presentToast("Search completed");
        }
      } catch(error) {
        this.loaderTab = false;
        let serviceError = migratedTryParseServiceError(error);
        new ToastUtils().presentToast(serviceError.description);
      }
      
    },
    areFiltersEqual(a, b) {
      return JSON.stringify(a) === JSON.stringify(b);
    },
    async loadPage(page) {
      try {
        localStorage.setItem("reservationPage", page);
        this.loaderTab = true;
        this.pageNo = page;
        this.pagesList = new PaginationUtils().getPagesList(
          this.totalRecords,
          this.pageRecords,
          page
        );
        let result = await new EVCStationReservationService().reservationsAccessibleByUserAtPageByPaginatedWithSizeMatchingQuery(
          new LocalStorage().user,
          this.pageNo,
          this.pageRecords,
          {
            id: this.id,
            station: {
              name: this.stationName,
            },
            customer: {
              name: this.customerName,
            },
            reservedBetween: {
              from: this.reservFrom ? new Date(this.reservFrom) : null,
              to: this.reservTo ? new Date(this.reservTo) : null,
            },
            types: null, //new EVChargingReservationTypeCode[{}],
            status: new EVChargingReservationStatus(this.status, ""),
            invoicedBetween: {
              from: this.invoiceFrom ? new Date(this.invoiceFrom) : null,
              to: this.invoiceTo ? new Date(this.invoiceTo) : null,
            },
            invoiceNumber: this.invoiceNo,
            stopReason: this.reason,
          }
        );
        this.totalRecords = result.total;
        this.reservations = result.fetched;
        this.loaderTab = false;
      }  catch(error) {
        this.loaderTab = false;
        let serviceError = migratedTryParseServiceError(error);
        new ToastUtils().presentToast(serviceError.description);
      }
      
    },
  },
})
</script>

<style scoped>
.status-completed {
  background: #21b24b 0% 0% no-repeat padding-box;
  border-radius: 36px;
  padding-left: 5px;
  padding-top: 0px;
  padding-right: 5px;
  padding-bottom: 0px;
  text-align: left;
  font-family: "Roboto Medium";
  font-size: 13px;
  letter-spacing: 0;
  color: #ffffff;
  opacity: 1;
}

.status-cancelled {
  background: #a7a7a7 0% 0% no-repeat padding-box;
  border-radius: 36px;
  padding-left: 5px;
  padding-top: 0px;
  padding-right: 5px;
  padding-bottom: 0px;
  text-align: left;
  font-family: "Roboto Medium";
  font-size: 13px;
  letter-spacing: 0;
  color: #ffffff;
  opacity: 1;
}
.limit-length {
  width: 1% !important;
  white-space: nowrap !important;
  overflow: hidden !important;
  text-overflow: ellipsis !important;
}
</style>